type ImageComponentProps = {
  src: string;
  className?: string;
  alt?: string;
};

export default function ImageComponent(props: ImageComponentProps) {
  return <img src={props.src} className={props.className} alt={props.alt} width={'1200px'} />;
}
